import React from "react";
import { Typography, Layout } from "antd";

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const TermsOfUse = () => {
  return (
    <Layout style={{ background: "#fff" }}>
      <Content
        style={{ padding: "60px 80px", maxWidth: 1000, margin: "0 auto", marginTop: "-40px", }}
      >
        {/* Title Box */}
        <div
          style={{
            height: "50px",
            width: "230px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "20px auto",
            borderRadius: "20px",
            padding: "20px",
          }}
          data-aos="zoom-in"
        >
          <Title level={2} style={{ margin: 0 }}>
            Terms of Use
          </Title>
        </div>

        <Typography>
          <Paragraph>
            <Text strong>Effective Date:</Text> 1 November 2025
          </Paragraph>

          <Title level={4}>1. Introduction</Title>
          <Paragraph>
            1.1 These Terms of Service ("Terms") govern your access to and use of
            the services provided by <Text strong>Yalla Nellab</Text> ("we,"
            "us," "our"), a company incorporated in the United Arab Emirates.
          </Paragraph>
          <Paragraph>
            1.2 By registering for an event or creating an account on our
            website, you ("you," "user," "participant") acknowledge that you have
            read, understood, and agree to be bound by these Terms. If you do
            not agree, you must not use our services.
          </Paragraph>

          <Title level={4}>2. Description of Services</Title>
          <Paragraph>
            2.1 Yalla Nellab organizes and facilitates events including but not
            limited to: football, cricket, jiu-jitsu tournaments, events for
            special children, community labor tournaments, and related
            activities ("Events").
          </Paragraph>
          <Paragraph>
            2.2 Events may be free or paid. Registration is required (by teams or
            individual tickets) via our website or platform.
          </Paragraph>
          <Paragraph>
            2.3 We host Events in the UAE and may change event formats, venues,
            dates, or times as necessary.
          </Paragraph>

          <Title level={4}>3. Eligibility & Registration</Title>
          <Paragraph>
            3.1 Participants must meet the minimum age requirements: for sports
            events (football, cricket, jiu-jitsu) minimum age is 12 years; for
            outdoor "Activities for Special Children" events minimum age is 6 years.
          </Paragraph>
          <Paragraph>
            3.2 For school matches, company age-group tournaments or team
            entries, you must be affiliated with the relevant school, company or
            category, and verification (e.g., ID, school/company proof or age
            grouping) will be required at time of the match. Falsifying
            information or misrepresentation may lead to disqualification of the
            team or individual.
          </Paragraph>
          <Paragraph>
            3.3 Users must provide accurate and complete registration information
            and are responsible for keeping their account credentials secure.
          </Paragraph>

          <Title level={4}>4. Payment, Refunds & Cancellation</Title>
          <Paragraph>
            4.1 For paid Events, registration and/or ticket payment must be made
            according to the procedure specified on the website.
          </Paragraph>
          <Paragraph>
            4.2 Refunds are only available if Yalla Nellab cancels the Event. No
            other refunds will apply (e.g., you choose not to attend).
          </Paragraph>
          <Paragraph>
            4.3 We reserve the right to cancel, postpone or modify Events for any
            reason (including low registrations, weather, venue issues). In such
            case we will notify you and offer a refund if applicable under clause 4.2.
          </Paragraph>

          <Title level={4}>5. User Conduct & Participation</Title>
          <Paragraph>
            5.1 You must comply with all rules and guidelines of the Event (e.g.,
            check-in, verification, ID check, age groups). Failure to comply may
            result in disqualification or exclusion from participating in current or future Events.
          </Paragraph>
          <Paragraph>
            5.2 You are responsible for your behavior and safety during each Event. We encourage you to use your best judgment, follow Event-organizer instructions, and abide by applicable local laws.
          </Paragraph>
          <Paragraph>
            5.3 You may take photographs or videos of Events and post them on social media. However, Yalla Nellab retains all rights to broadcast, stream, record or display the full match or Event. Your use of content must not infringe our rights.
          </Paragraph>

          <Title level={4}>6. Intellectual Property</Title>
          <Paragraph>
            6.1 All intellectual property rights in our website, branding, Event
            materials, recordings and live streams remain with Yalla Nellab or its
            licensors.
          </Paragraph>
          <Paragraph>
            6.2 By participating, you grant Yalla Nellab the non-exclusive,
            royalty-free right to use your image, video or photograph taken during
            the Event for promotional, marketing or other lawful purposes.
          </Paragraph>

          <Title level={4}>7. Limitation of Liability</Title>
          <Paragraph>
            7.1 To the maximum extent permitted by law, Yalla Nellab shall not be
            liable for any indirect, incidental, special, or consequential damages
            arising out of or in connection with your participation or use of our Services.
          </Paragraph>
          <Paragraph>
            7.2 We do not guarantee that an Event will proceed exactly as described; we shall not be liable for any losses if an Event is canceled, postponed or modified (other than refund under clause 4.2).
          </Paragraph>
          <Paragraph>
            7.3 Nothing in these Terms shall exclude or limit liability for death or
            personal injury caused by our negligence or any other liability which cannot lawfully be limited under UAE law.
          </Paragraph>

          <Title level={4}>8. Termination</Title>
          <Paragraph>
            8.1 We reserve the right to suspend or terminate your account or
            participation if you breach these Terms, provide false information, or
            behave inappropriately.
          </Paragraph>
          <Paragraph>
            8.2 Upon termination, your rights to access the Service will cease immediately. Any refunds will be handled as per clause 4.
          </Paragraph>

          <Title level={4}>9. Amendments</Title>
          <Paragraph>
            9.1 We may amend these Terms at any time. We will publish the updated Terms on our website and update the "Effective Date" accordingly. Your continued use of our Services after amendments means you accept the updated Terms.
          </Paragraph>
          <Paragraph>
            9.2 You should review these Terms periodically.
          </Paragraph>

          <Title level={4}>10. Governing Law & Jurisdiction</Title>
          <Paragraph>
            10.1 These Terms shall be governed by and construed in accordance with the laws of the United Arab Emirates.
          </Paragraph>
          <Paragraph>
            10.2 Any dispute arising out of or relating to these Terms shall be subject to the exclusive jurisdiction of the courts of the UAE.
          </Paragraph>

          <Title level={4}>11. Contact Information</Title>
          <Paragraph>
            If you have any questions about these Terms, please contact us through our contact form.
          </Paragraph>
        </Typography>
      </Content>
    </Layout>
  );
};

export default TermsOfUse;